import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import Card from 'forms/shared/fields/card'
import TextField from 'forms/shared/fields/text'
import { connect } from 'react-redux'

const BillingFields = ({
  bookingDetails: { bankDetails },
  paymentOption = '',
  setPaymentOption,
  clientApplyCode,
  promoCode,
  id,
  promotionMessage,
  promotionValid,
}) => {
  function createMarkup() {
    return { __html: bankDetails }
  }

  const renderBankField = () => (
    <div className="text-primary-lightgray" dangerouslySetInnerHTML={createMarkup()} />
  )

  return (
    <div className="my-5">
      <h2 className="text-2xl font-semibold">Payment Options</h2>
      <div className="my-3 border rounded-lg p-3">
        <span
          className="flex justify-between items-center cursor-pointer"
          onClick={() => setPaymentOption('credit-card')}
        >
          <p className="text-xl font-semibold">CARD</p>
          <i
            className={`fa fa-check ${paymentOption === 'credit-card' && 'text-primary-orange'}`}
            aria-hidden="true"
          ></i>
        </span>
        {paymentOption === 'credit-card' && <Field name="card" component={Card} />}
      </div>
      <div className="my-3 border rounded-lg p-3">
        <span
          className="flex justify-between items-center cursor-pointer"
          onClick={() => setPaymentOption('bank-deposit')}
        >
          <p className="text-xl font-semibold">BANK</p>
          <i
            className={`fa fa-check ${paymentOption === 'bank-deposit' && 'text-primary-orange'}`}
            aria-hidden="true"
          ></i>
        </span>
        {paymentOption === 'bank-deposit' && (
          <Field name="bank" value="bank" component={renderBankField} />
        )}
      </div>
      <div className="my-5">
        <p className="text-lg font-semibold text-primary-orange mb-2">Promo code</p>
        <div className="flex justify-between">
          <Field
            type="input"
            name={`promo_code`}
            inputClassName={`border rounded-lg flex-1 p-2`}
            component={TextField}
          />
          <button
            type="button"
            className="btn-primary px-12 py-2 rounded-lg mx-5"
            onClick={() => clientApplyCode({ promoCode, id })}
          >
            Apply
          </button>
        </div>
        <div>
          <div className={`${promotionValid ? `text-green-500` : `text-red-500`}`}>
            {promotionMessage}
          </div>
        </div>
      </div>
    </div>
  )
}

BillingFields.propTypes = {
  bookingDetails: PropTypes.object,
  paymentOption: PropTypes.string.isRequired,
  setPaymentOption: PropTypes.func.isRequired,
  clientApplyCode: PropTypes.func,
  promoCode: PropTypes.string,
  form: PropTypes.string,
  id: PropTypes.string,
  promotionMessage: PropTypes.string,
  promotionValid: PropTypes.bool,
}

const mapStateToProps = (state, ownProps) => {
  let selector
  const form = ownProps.form
  if (form) selector = formValueSelector(form)
  const promotionDiscount = state.promocodes?.promo_discount
  const promotionMessage = promotionDiscount ? promotionDiscount.message : ''
  const promotionValid = promotionDiscount ? promotionDiscount.valid : false
  return {
    promoCode: selector ? selector(state, 'promo_code') : '',
    promotionValid,
    promotionMessage,
  }
}

export default connect(mapStateToProps, null)(BillingFields)
